// extracted by mini-css-extract-plugin
module.exports = {"link":"MegaMenuItems_link__Lv9xB","disabled":"MegaMenuItems_disabled__1lclL"};